import * as types from "./actionTypes";

export const loadUsers = (users) => ({
  type: types.LOAD_USERS,
  payload: users,
});
